import React from "react";
var __jsx = React.createElement;
function Sms(props) {
  return __jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24"
  }, __jsx("path", {
    fill: "currentColor",
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 14H5.17L4 17.17V4h16v12ZM7 9h2v2H7V9Zm8 0h2v2h-2V9Zm-4 0h2v2h-2V9Z"
  }));
}
export default Sms;